import '@backstage/cli/asset-types';
import ReactDOM from 'react-dom/client';
import app from './App';
import '@backstage/ui/css/styles.css';
import './themes/my-custom-arrive-theme.css';

// Default sidebar to collapsed (unpinned) for new users;
// existing users who already toggled it keep their preference.
try {
  if (window.localStorage.getItem('sidebarPinState') === null) {
    window.localStorage.setItem('sidebarPinState', 'false');
  }
} catch {
  // Ignore storage access failures during startup; preference is best-effort only.
}

ReactDOM.createRoot(document.getElementById('root')!).render(app);
